import React, { useEffect, useState } from "react";
import firstimg from "../../../../img/result.png";
import NavHear from "../NavHear";
import Footer from "../TestFooter/Footer";
import { Link, useNavigate } from "react-router-dom";
import leftimg from "../../../../img/left-ear-icon.webp";
import rightimg from "../../../../img/right-ear-icon.png";
import Modal from "react-modal";
import { ImCross } from "react-icons/im";
import { useDispatch } from "react-redux";
import { hearingpdfview } from "../../../../Helper/Redux/API";
import { toast } from "react-toastify";

function Result() {
  const disptach = useDispatch();
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  const history = useNavigate();
  const [selectedOption, setSelectedOption] = useState(""); // state to track selected option
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    // Determine the route path based on the selected option
    let routePath;
    if (e.target.value === "option2") {
      routePath = "/Calendar";
    } else if (e.target.value === "option3") {
      localStorage.removeItem("step2");
      localStorage.removeItem("step3");
      localStorage.removeItem("step4");
      localStorage.removeItem("step5");
      localStorage.removeItem("step6");
      localStorage.removeItem("step7");
      localStorage.removeItem("step8");
      localStorage.removeItem("step9");
      localStorage.removeItem("Rightear2KHz");
      localStorage.removeItem("Rightear4KHz");
      localStorage.removeItem("Leftear1KHz");
      localStorage.removeItem("Leftear6KHz");
      localStorage.removeItem("Measuretest");
      localStorage.removeItem("result_test_id");
      localStorage.removeItem("Rightear500Hz");
      localStorage.removeItem("rightear1KHz");
      localStorage.removeItem("Leftear500Hz");
      localStorage.removeItem("Leftear2000KHz");
      routePath = "/Heartest";
    } else {
      // Default path or handle other options
      routePath = "/Calendar";
      localStorage.removeItem("step2");
      localStorage.removeItem("step3");
      localStorage.removeItem("step4");
      localStorage.removeItem("step5");
      localStorage.removeItem("step6");
      localStorage.removeItem("step7");
      localStorage.removeItem("step8");
      localStorage.removeItem("step9");
      localStorage.removeItem("Rightear2KHz");
      localStorage.removeItem("Rightear4KHz");
      localStorage.removeItem("Leftear1KHz");
      localStorage.removeItem("Leftear6KHz");
      localStorage.removeItem("Measuretest");
      localStorage.removeItem("result_test_id");
      localStorage.removeItem("Rightear500Hz");
      localStorage.removeItem("rightear1KHz");
      localStorage.removeItem("Leftear500Hz");
      localStorage.removeItem("Leftear2000KHz");
    }

    // Navigate to the determined route path after a delay
    // setTimeout(() => {
    history(routePath);
    window.scrollTo({ top: 0, behavior: "smooth" });
    // }, 1000);
  };

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }
  const [pdfdownload, setPdfDownload] = useState("");
  const [tone, setTone] = useState("");
  const [tone1, setTone1] = useState("");
  const [tone2, setTone2] = useState("");
  const [tone3, setTone3] = useState("");
  const [tone4, setTone4] = useState("");
  const [tone5, setTone5] = useState("");
  const [tone6, setTone6] = useState("");
  const [tone7, setTone7] = useState("");
  const [tone8, setTone8] = useState("");
  const [tone9, setTone9] = useState("");
  const [tone10, setTone10] = useState("");
  const [tone11, setTone11] = useState("");

  const Savepdf = () => {
    const hearingpdfdata = {
      test_id: localStorage.getItem("result_test_id"),
    };

    disptach(hearingpdfview(hearingpdfdata)).then((res) => {
      if (res?.payload?.status === false) {
        toast.error(res?.payload?.message);
      } else {
        // toast.success(res?.payload?.message);
        setPdfDownload(res?.payload.pdf);
        // console.log("new", res?.payload?.data[0]?.points);
        setTone(res?.payload?.data[0]?.points);
        setTone1(res?.payload?.data[1]?.points);
        setTone2(res?.payload?.data[2]?.points);
        setTone3(res?.payload?.data[3]?.points);
        setTone4(res?.payload?.data[4]?.points);
        setTone5(res?.payload?.data[5]?.points);
        setTone6(res?.payload?.data[6]?.points);
        setTone7(res?.payload?.data[7]?.points);
        setTone8(res?.payload?.data[8]?.points);
        setTone9(res?.payload?.data[9]?.points);
        setTone10(res?.payload?.data[10]?.points);
        setTone11(res?.payload?.data[11]?.points);
      }
    });
  };

  useEffect(() => {
    Savepdf();
  }, []);
  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            <section className="step_1 step2 step9  wow  fadeInUp animated">
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <img src={firstimg} className="img-fluid" alt="first-img" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text">
                    <h1>
                      The Hearing Screener result suggests that you may have
                      hearing loss.
                    </h1>
                    <div className="accound">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              What does this mean?
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              People with this result tend to experience
                              significant hearing difficulties in everyday
                              listening situations.
                              <br />
                              <br />
                              <button onClick={openModal}>
                                Detailed Results
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              Next Step
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              It is encouraged that a more thorough examination
                              of your hearing is warranted as this Hearing
                              Screener is not a substitute for a professional
                              hearing test. Please contact us to setup an
                              appointment at Phonak. Monitor and protect your
                              hearing.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="step2_seletct step4_seletct">
                      <ul className="list_item">
                        <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "option2" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              value="option2"
                              checked={selectedOption === "option2"}
                              onChange={handleRadioChange}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio2"
                            >
                              Find a professional
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className={`form-check form-check-inline ${
                              selectedOption === "option3" ? "checked" : ""
                            }`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio3"
                              value="option3"
                              checked={selectedOption === "option3"}
                              onChange={handleRadioChange}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio3"
                            >
                              Do the test again
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
        <Footer />
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        shouldCloseOnOverlayClick={false}
        id="warning"
      >
        <button onClick={closeModal} className="cross_btn_warning">
          <ImCross />
        </button>
        <div className="body  Pdfhearing">
          <h1>Detailed Results</h1>

          <div className="hearingpdftable">
            <ul className="firstpdf">
              <li>
                <span></span>
              </li>
              <li>
                <span>Good hearing</span>
              </li>
              <li>
                <span>Mild issues</span>
              </li>
              <li>
                <span>Moderate issues</span>
              </li>
              <li>
                <span>Severe issues</span>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 1</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone}%`,
                    backgroundColor:
                      tone >= 80
                        ? "#df4800"
                        : tone >= 50
                        ? "#e99b23"
                        : tone >= 30
                        ? "#edea68"
                        : tone >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone1}%`,
                    backgroundColor:
                      tone1 >= 80
                        ? "#df4800"
                        : tone1 >= 50
                        ? "#e99b23"
                        : tone1 >= 30
                        ? "#edea68"
                        : tone1 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 2</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone2}%`,
                    backgroundColor:
                      tone2 >= 80
                        ? "#df4800"
                        : tone2 >= 50
                        ? "#e99b23"
                        : tone2 >= 30
                        ? "#edea68"
                        : tone2 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone3}%`,
                    backgroundColor:
                      tone3 >= 80
                        ? "#df4800"
                        : tone3 >= 50
                        ? "#e99b23"
                        : tone3 >= 30
                        ? "#edea68"
                        : tone3 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 3</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone4}%`,
                    backgroundColor:
                      tone4 >= 80
                        ? "#df4800"
                        : tone4 >= 50
                        ? "#e99b23"
                        : tone4 >= 30
                        ? "#edea68"
                        : tone4 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone5}%`,
                    backgroundColor:
                      tone5 >= 80
                        ? "#df4800"
                        : tone5 >= 50
                        ? "#e99b23"
                        : tone5 >= 30
                        ? "#edea68"
                        : tone5 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 4</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone6}%`,
                    backgroundColor:
                      tone6 >= 80
                        ? "#df4800"
                        : tone6 >= 50
                        ? "#e99b23"
                        : tone6 >= 30
                        ? "#edea68"
                        : tone6 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone7}%`,
                    backgroundColor:
                      tone7 >= 80
                        ? "#df4800"
                        : tone7 >= 50
                        ? "#e99b23"
                        : tone7 >= 30
                        ? "#edea68"
                        : tone7 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 5</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone8}%`,
                    backgroundColor:
                      tone8 >= 80
                        ? "#df4800"
                        : tone8 >= 50
                        ? "#e99b23"
                        : tone8 >= 30
                        ? "#edea68"
                        : tone8 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone9}%`,
                    backgroundColor:
                      tone9 >= 80
                        ? "#df4800"
                        : tone9 >= 50
                        ? "#e99b23"
                        : tone9 >= 30
                        ? "#edea68"
                        : tone9 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="second_pdf">
              <li className="pdf_second ">
                <span>Tone 6</span>
                <div className="img_pdf">
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" />
                  <div className="img_pdf">
                    {" "}
                    <img src={leftimg} className="img-fluid ear-icon" />
                  </div>
                </div>
              </li>
              <li>
                <div
                  className="color_div"
                  style={{
                    width: `${tone10}%`,
                    backgroundColor:
                      tone10 >= 80
                        ? "#df4800"
                        : tone10 >= 50
                        ? "#e99b23"
                        : tone10 >= 30
                        ? "#edea68"
                        : tone10 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
                <div
                  className="color_div"
                  style={{
                    width: `${tone11}%`,
                    backgroundColor:
                      tone11 >= 80
                        ? "#df4800"
                        : tone11 >= 50
                        ? "#e99b23"
                        : tone11 >= 30
                        ? "#edea68"
                        : tone11 >= 10
                        ? "#91d050"
                        : "#91d050",
                  }}
                ></div>
              </li>
            </ul>

            <ul className="firstpdf pdf_last">
              <li>
                <span></span>
              </li>
              <li>
                <span>0</span>
              </li>
              <li>
                <span>10</span>
              </li>
              <li>
                <span>20</span>
              </li>
              <li>
                <span>30</span>
              </li>

              <li>
                <span>40</span>
              </li>

              <li>
                <span>50</span>
              </li>

              <li>
                <span>60</span>
              </li>

              <li>
                <span>70</span>
              </li>

              <li>
                <span>80</span>
              </li>

              <li>
                <span>90</span>
              </li>
            </ul>

            <br />

            <h1> Estimates only (not a clinical audiogram!) </h1>
            <br />
            <ul className="firstpdf pdf_last total_pdf">
              <li>
                <span>
                  {" "}
                  <img src={rightimg} className="img-fluid ear-icon" /> Right
                  Ear
                </span>
              </li>
              <li>
                <span>45db</span>
              </li>
              <li>
                <span>45db</span>
              </li>
              <li>
                <span>50db</span>
              </li>
              <li>
                <span>55db</span>
              </li>

              <li>
                <span>60db</span>
              </li>

              <li>
                <span>50db</span>
              </li>

              <li>
                <span>60db</span>
              </li>

              <li>
                <span>60db</span>
              </li>
            </ul>

            <ul className="firstpdf pdf_last">
              <li>
                <span>
                  {" "}
                  <img src={leftimg} className="img-fluid ear-icon" /> Left Ear
                </span>
              </li>
              <li>
                <span>45db</span>
              </li>
              <li>
                <span>45db</span>
              </li>
              <li>
                <span>50db</span>
              </li>
              <li>
                <span>55db</span>
              </li>

              <li>
                <span>60db</span>
              </li>

              <li>
                <span>50db</span>
              </li>

              <li>
                <span>60db</span>
              </li>

              <li>
                <span>60db</span>
              </li>
            </ul>

            <div className="pdf_save_btn">
              <a href={pdfdownload} className="btn" target="_blank">
                Save Pdf
              </a>
              &nbsp;&nbsp;
              <button className="btn" onClick={closeModal}>
                close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Result;
